<template>
  <el-card class="detail-card" shadow="never">
    <div slot="header" class="card-header">
      <span class="card-title"><i class="el-icon-document"></i> 项目概况</span>
    </div>
    <el-descriptions :column="3" border size="medium" class="info-desc">
      <el-descriptions-item label="项目编号">{{ projectInfo.projectCode || '—' }}</el-descriptions-item>
      <el-descriptions-item label="项目类型">{{ projectInfo.projectType || '—' }}</el-descriptions-item>
      <el-descriptions-item label="项目状态">
        <el-tag :type="statusType" size="mini">{{ projectInfo.projectStatus || '—' }}</el-tag>
      </el-descriptions-item>
      <el-descriptions-item label="建设地点">{{ projectInfo.buildLocation || '—' }}</el-descriptions-item>
      <el-descriptions-item label="建设规模">{{ projectInfo.buildScale || '—' }}</el-descriptions-item>
      <el-descriptions-item label="总投资">{{ projectInfo.totalInvestment || '—' }}</el-descriptions-item>
      <el-descriptions-item label="立项时间">{{ projectInfo.approvalDate || '—' }}</el-descriptions-item>
      <el-descriptions-item label="预计开工">{{ projectInfo.planStartDate || '—' }}</el-descriptions-item>
      <el-descriptions-item label="预计竣工">{{ projectInfo.planEndDate || '—' }}</el-descriptions-item>
      <el-descriptions-item label="建设单位">{{ projectInfo.buildUnit || '—' }}</el-descriptions-item>
      <el-descriptions-item label="招标方式">{{ projectInfo.bidType || '—' }}</el-descriptions-item>
      <el-descriptions-item label="行业分类">{{ projectInfo.industryType || '—' }}</el-descriptions-item>
    </el-descriptions>
    <div class="desc-block">
      <div class="desc-label">项目简介</div>
      <div class="desc-content">{{ projectInfo.projectDesc || '暂无项目简介' }}</div>
    </div>
  </el-card>
</template>

<script>
export default {
  name: 'ProjectOverviewCard',
  props: {
    // 项目基本信息，由父组件请求 project/Detail 后传入（baseInfo）
    baseInfo: { type: Object, default: () => ({}) }
  },
  computed: {
    // baseInfo 字段 -> 模板字段映射
    projectInfo() {
      const baseInfo = this.baseInfo || {}
      return {
        projectCode: baseInfo.projectCode || '',
        projectName: baseInfo.projectName || '',
        projectType: baseInfo.dataSourceName || '',
        projectStatus: baseInfo.sourceTypeName || '',
        buildLocation: [baseInfo.province, baseInfo.city, baseInfo.county].filter(Boolean).join(''),
        buildScale: '',
        totalInvestment: (baseInfo.money || baseInfo.money === 0) ? baseInfo.money + (baseInfo.moneyUnit || '') : '',
        approvalDate: baseInfo.finishDate || '',
        planStartDate: '',
        planEndDate: '',
        buildUnit: baseInfo.companyName || '',
        bidType: '',
        industryType: baseInfo.industryName || '',
        projectDesc: baseInfo.remark || baseInfo.title || ''
      }
    },
    statusType() {
      const map = {
        '立项备案': 'info',
        '专项审核': 'info',
        '用地审批': 'warning',
        '规划设计': 'warning',
        '招标公告': 'danger',
        '施工许可': 'success',
        '开工建设': 'success'
      }
      return map[this.projectInfo.projectStatus] || 'info'
    }
  }
}
</script>

<style lang="scss" scoped>
/* 卡片统一样式 */
.detail-card {
  border-radius: 8px;
  border: 1px solid #ebeef5;
  ::v-deep .el-card__header {
    padding: 14px 20px;
    border-bottom: 1px solid #ebeef5;
    background: #fafbfc;
  }
  ::v-deep .el-card__body {
    padding: 20px;
  }
}
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.card-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  i {
    margin-right: 6px;
    color: #409eff;
  }
}

/* 项目概况描述列表 */
.info-desc {
  ::v-deep .el-descriptions__body {
    .el-descriptions__table {
      .el-descriptions-item__cell {
        font-size: 13px;
      }
      .el-descriptions-item__label {
        width: 100px;
        color: #606266;
        background: #f5f7fa;
      }
    }
  }
}
.desc-block {
  margin-top: 16px;
  .desc-label {
    font-size: 13px;
    font-weight: 600;
    color: #606266;
    margin-bottom: 8px;
  }
  .desc-content {
    font-size: 13px;
    color: #606266;
    line-height: 1.8;
    background: #f5f7fa;
    padding: 12px 16px;
    border-radius: 4px;
  }
}
</style>